import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoginPayload, RegisterPayload } from '../../../services/authApi';
import { LoginState } from './types';

export const initialState: LoginState = {
  loading: false,
  error: null,
};

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loginRequest(state, _action: PayloadAction<LoginPayload>) {
      state.loading = true;
      state.error = null;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    registerRequest(state, _action: PayloadAction<RegisterPayload>) {
      state.loading = true;
      state.error = null;
    },
    authSuccess(state) {
      state.loading = false;
      state.error = null;
    },
    authFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

export const { actions: loginActions } = loginSlice;

export const useLoginSlice = () => ({ actions: loginSlice.actions });
